import { mapObjectOwnValues } from 'common/utils/object.utils';
import { CastAllowedTypes, castValueFromString } from './env.utils';

// Constant storage prefix
export const STORAGE_KEY_PREFIX = 'APP_';

/**
 * Get internal key for local/session storage items
 * @returns {string}
 */
export const getStorageKey = (...args: string[]): string => {
  const key = args.filter(arg => arg?.toString().length > 0).join('.');
  if (key.length > 0) {
    return `${STORAGE_KEY_PREFIX}.${key}`;
  } else {
    return undefined;
  }
};

/**
 * Utility method to create a readonly dictionary of config flags which values are
 * stored and exposed in local storage.
 * @param defaultValues Dictionary of desired keys and its default values.
 * @returns Dictionary of config flags bound to local storage.
 */
export const createConfigFromLocalStorage = <T extends Record<string, string | number | boolean>>(
  defaultValues: T
): Readonly<T> =>
  Object.defineProperties<T>(
    {} as T,
    mapObjectOwnValues(defaultValues, (defaultValue, key) => ({
      get: () => {
        // Get local storage key
        const localStorageKey = getStorageKey(String(key));
        // Extract value from local storage, if it does not exist, initialize it.
        let localValue = globalThis.localStorage.getItem(localStorageKey);
        if (!localValue) {
          localValue = defaultValue?.toString();
          globalThis.localStorage.setItem(localStorageKey, localValue);
        }
        // Return casted value
        const valueType = typeof defaultValue;
        return castValueFromString(localValue, valueType as CastAllowedTypes);
      },
      enumerable: true,
    }))
  );
